const BRIGHTCOVE_API_URL = '/api/brightcove/v1/videos';

export default class Players {
  static async getBrightCoveViewer(brightCoveId) {
    try {
      if (window && window.Vue && window.Vue.http) {
        return window.Vue.http.get(`${BRIGHTCOVE_API_URL}/${brightCoveId}/player`);
      } else {
        throw new Error('No Vue instance defined');
      }
    } catch (error) {
      throw new Error(error);
    }
  }
}
